import React from 'react';
import { FormContext, useForm } from 'react-hook-form';
import { useMountedSafeState } from 'features/sendouts/hooks/useMountedSafeState';
import strings from 'strings';
import FPButtonBuilder from 'UI/components/molecules/FPButtonBuilder';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { DECLINATION_REASONS_FIELD_NAMES } from './DeclinationReasons.constants';
import {
  buildDeclinationPayload,
  getDeclinationFormInitialValues
} from './DeclinationReasonsDrawer.utils';
import { ReasonsSelector } from './ReasonsSelector';

const { declinationReasons: STRINGS } = strings.sendoutsV2.form.sections;

export const DeclinationReasonsDrawerBase = ({
  commentsLabel = STRINGS.commentsLabel,
  commentsPlaceholder = STRINGS.commentsLabel,
  initialValues,
  onClose = () => {},
  onSaved = () => {},
  reasons = [],
  reasonsValidationMessage = STRINGS.reasonsValidationMessage,
  statusId,
  subtitle = STRINGS.subtitle,
  title
}) => {
  const form = useForm({
    defaultValues: getDeclinationFormInitialValues(initialValues)
  });
  const { handleSubmit } = form;
  const [uiState, setUIState] = useMountedSafeState({
    isLoading: false
  });

  const handleSave = async data => {
    const payload = {
      status_id: statusId,
      ...buildDeclinationPayload(data)
    };

    setUIState(prev => ({ ...prev, isLoading: true }));

    try {
      await onSaved({ payload });
    } finally {
      setUIState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const buttonDefinitions = [
    {
      props: {
        text: strings.shared.ui.cancel,
        variant: 'outlined',
        onClick: onClose,
        disabled: uiState.isLoading
      },
      GridItemProps: { md: 3 }
    },
    {
      props: {
        text: strings.shared.ui.save,
        variant: 'contained',
        onClick: handleSubmit(handleSave),
        disabled: uiState.isLoading,
        isSaving: uiState.isLoading
      },
      GridItemProps: { md: 3 },
      mode: 'save'
    }
  ];

  return (
    <FPDrawer
      FPDrawerProps={{ open: true }}
      CardHeaderProps={{ title }}
      onClose={onClose}
      footer={
        <FPButtonBuilder
          GridContainerProps={{ spacing: 2 }}
          buttonDefinitions={buttonDefinitions}
        />
      }
    >
      <FormContext {...form}>
        <ReasonsSelector
          commentsFieldName={DECLINATION_REASONS_FIELD_NAMES.DeclinationNotes}
          commentsLabel={commentsLabel}
          commentsPlaceholder={commentsPlaceholder}
          reasons={reasons}
          reasonsFieldName={DECLINATION_REASONS_FIELD_NAMES.DeclinedFields}
          reasonsValidationMessage={reasonsValidationMessage}
          subtitle={subtitle}
        />
      </FormContext>
    </FPDrawer>
  );
};
